import React from 'react';
import './timetable.css';
import { useDispatch, useSelector } from "react-redux";
import { setScheduleAction } from "../../redux/actions";
import { getTimetableSagaAction } from "../../redux/sagaActions";

const Timetable = () => {
    const dispatch = useDispatch();
    const schedule = useSelector(state => state.schedule);

    return (
        <div className="timetable">
            <div className="timetable__calendar">
                <input type="date"
                       className="input"
                       value={ schedule.date }
                       onChange={ event => {
                           // Запрашиваем новые данные
                           dispatch(getTimetableSagaAction({
                               date: event.target.value
                           }));
                       } }
                />
            </div>
            <div className="timetable__items">
                {
                    schedule.times.map((elem, index) => (
                        <div key={ index }
                             className={ `timetable__item ${ elem.time === schedule.selected_time ? 'timetable__item--active' : '' } ${ !elem.active ? 'timetable__item--inactive' : '' }` }
                             onClick={ () => {
                                 let time_new_value = '';

                                 if (schedule.selected_time !== elem.time) {
                                     time_new_value = elem.time;
                                 }

                                 dispatch(setScheduleAction({
                                     ...schedule,
                                     selected_time: time_new_value
                                 }));
                             } }
                        >{ elem.time }</div>
                    ))
                }
            </div>
        </div>
    );
};

export default Timetable;